var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 66,
    viewBox: "0 0 76 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6035 0C66.6013 0 75.5175 8.91537 75.5176 19.9131C75.5176 19.9831 75.5154 20.0532 75.5146 20.123H75.5176C75.5175 25.2545 73.3795 35.7087 61.2773 46.3164C48.205 57.7742 40.1767 64.2129 37.7969 66C32.7445 62.8086 20.5476 52.911 12.4844 44.8232C5.34252 37.6596 1.12027 30.5976 0.248047 23.0635C0.0849697 22.0374 0 20.9851 0 19.9131C0.000112357 8.91544 8.91544 0.000112364 19.9131 0C27.7341 0 34.5014 4.50923 37.7588 11.0693C41.0161 4.50943 47.7827 0.000167875 55.6035 0Z",
    fill: "#FED42B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 66,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.84155d62bc715d85c2262cc2c55d3f25.svg";
export { ForwardRef as ReactComponent };